import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { UserFilter } from '../../../models/users/userFilter';

@Component({
  selector: 'user-filter',
  templateUrl: './user-filter.component.html',
  styleUrls: ['./user-filter.component.css']
})
export class UserFilterComponent implements OnInit {
	showFilter: boolean = false;
	
	@Input() filter: UserFilter = new UserFilter();
	@Output() search: EventEmitter<UserFilter> = new EventEmitter<UserFilter>()
	
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showFilter = false;
	}

	constructor(private _elementRef: ElementRef,) { }

	ngOnInit() {
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	onSearchClick() {
		this.search.emit(this.filter);
		this.showFilter = false;
	}

	onClearClick() {
		this.filter.name = null;
		this.filter.email = null;
		this.filter.employeeRole = null;
		this.filter.isActive = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/users/user-filter/user-filter.component.ts